{
  "responseShape": "サーバーの応答が想定された形式と一致しません。更新してください。",
  "badRequest": "リクエストが無効です。入力内容をご確認ください。",
  "forbidden": "この操作を実行する権限がありません。",
  "facilityRequired": "このモジュールを使うには、ヘッダーで施設を選択してください。",
  "notFound": "リソースが見つかりません。",
  "conflict": "リソースは既に存在します。",
  "validation": "検証エラー。",
  "tooManyRequests": "リクエストが多すぎます。しばらくしてから再試行してください。",
  "serverError": "サーバーエラー。しばらくしてから再試行してください。",
  "unexpected": "予期しないエラーが発生しました。",
  "network": "ネットワークエラー。接続をご確認ください。",
  "requestSetup": "エラーが発生しました。再試行してください。",
  "sessionExpired": "セッションの有効期限が切れました。再ログインしてください。"
}
